




import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Alignments } from "../../domain/drawing";
import { OptionDropDownSelector } from "../system/selectors";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class AlignmentDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop()
  alignments: Alignments[];

  data(): any {
    return {
      options: [
        new StandardOption<Alignments>("左上", Alignments.TopLeft),
        new StandardOption<Alignments>("中央上", Alignments.TopCenter),
        new StandardOption<Alignments>("右上", Alignments.TopRight),
        new StandardOption<Alignments>("左中央", Alignments.MiddleLeft),
        new StandardOption<Alignments>("中央", Alignments.MiddleCenter),
        new StandardOption<Alignments>("右中央", Alignments.MiddleRight),
        new StandardOption<Alignments>("左下", Alignments.BottomLeft),
        new StandardOption<Alignments>("中央下", Alignments.BottomCenter),
        new StandardOption<Alignments>("右下", Alignments.BottomRight),
      ],
    };
  }
  options: StandardOption<Alignments>[];

  get selectableOptions(): StandardOption<Alignments>[] {
    return Enumerable.from(this.options)
      .where(o => 0 <= this.alignments.indexOf(o.value))
      .toArray();
  }
}
